import {
  BookOpen,
  CreditCard,
  LayoutDashboard,
  LifeBuoy,
  Megaphone,
  ServerCog,
  ShieldCheck,
  Users,
  type LucideIcon,
} from 'lucide-react';

/**
 * Ylläpidon rakenne. Ylläpito on vain suomeksi, joten tekstit ovat suoraan tässä
 * eivätkä käännöstiedostoissa.
 */
export interface AdminSection {
  key: string;
  label: string;
  icon: LucideIcon;
  subs: Array<{ key: string; label: string; text: string }>;
}

export const ADMIN_SECTIONS: AdminSection[] = [
  { key: '', label: 'Yhteenveto', icon: LayoutDashboard, subs: [] },
  {
    key: 'kayttajat',
    label: 'Käyttäjät',
    icon: Users,
    subs: [
      {
        key: 'vuokranantajat',
        label: 'Vuokranantajat',
        text: 'Vuokranantajien haku ja tiedot. Jokainen katselu kirjataan audit-lokiin.',
      },
      { key: 'vuokralaiset', label: 'Vuokralaiset', text: 'Vuokralaisten haku ja tiedot.' },
      { key: 'kaikki', label: 'Kaikki', text: 'Kaikki käyttäjät, istuntojen mitätöinti.' },
    ],
  },
  {
    key: 'asiakkuudet',
    label: 'Asiakkuudet',
    icon: CreditCard,
    subs: [
      {
        key: 'tilaukset',
        label: 'Tilaukset',
        text: 'Vuokranantajien tilaukset: ensimmäinen asunto ja lisäasunnot.',
      },
      { key: 'maksut', label: 'Maksut', text: 'Saapuneet maksut.' },
      {
        key: 'erääntyneet',
        label: 'Erääntyneet',
        text: 'Erääntyneet tilausmaksut ja muistutukset.',
      },
    ],
  },
  {
    key: 'tuki',
    label: 'Tuki',
    icon: LifeBuoy,
    subs: [
      {
        key: 'palautteet',
        label: 'Palautteet',
        text: 'Apua-painikkeen kautta tulleet palautteet ja kysymykset.',
      },
      {
        key: 'bugit',
        label: 'Bugi-ilmoitukset',
        text: 'Käyttäjien ilmoittamat virheet ja niiden tila.',
      },
    ],
  },
  {
    key: 'viestinta',
    label: 'Viestintä',
    icon: Megaphone,
    subs: [
      {
        key: 'tiedotteet',
        label: 'Tiedotteet',
        text: 'Tiedotteet kaikille tai valituille käyttäjille.',
      },
      {
        key: 'pohjat',
        label: 'Sähköpostipohjat',
        text: 'Kirjautumislinkin, kutsun, laskun ja muistutusten pohjat.',
      },
      {
        key: 'loki',
        label: 'Lähetysloki',
        text: 'Brevon kautta lähetetyt viestit ja niiden tila.',
      },
    ],
  },
  {
    key: 'tietoturva',
    label: 'Tietoturva',
    icon: ShieldCheck,
    subs: [
      {
        key: 'audit',
        label: 'Audit-loki',
        text: 'Muutokset ja adminin katselut: kuka, mitä, milloin.',
      },
      {
        key: 'kirjautumiset',
        label: 'Kirjautumiset',
        text: 'Kirjautumislinkkien pyynnöt ja epäonnistuneet yritykset.',
      },
      { key: 'istunnot', label: 'Istunnot', text: 'Aktiiviset istunnot ja niiden mitätöinti.' },
      {
        key: 'tietopyynnot',
        label: 'Tietopyynnöt',
        text: 'Käyttäjien tietojen lataus- ja poistopyynnöt sekä säilytysajat.',
      },
    ],
  },
  {
    key: 'jarjestelma',
    label: 'Järjestelmä',
    icon: ServerCog,
    subs: [
      {
        key: 'varmuuskopiot',
        label: 'Varmuuskopiot',
        text: 'Varmuuskopioiden tila, viimeisin onnistunut ja palautustesti.',
      },
      {
        key: 'ajastukset',
        label: 'Ajastukset',
        text: 'Ajastettujen töiden viimeisimmät ajot ja virheet.',
      },
      {
        key: 'integraatiot',
        label: 'Integraatiot',
        text: 'Brevon, Vero API:n ja tiedostotallennuksen tila.',
      },
      { key: 'virheloki', label: 'Virheloki', text: 'Backendin virheet.' },
    ],
  },
  {
    key: 'sisalto',
    label: 'Sisältö',
    icon: BookOpen,
    subs: [
      {
        key: 'sopimuspohjat',
        label: 'Sopimuspohjat',
        text: 'Vuokrasopimuspohjat ja niiden versiot.',
      },
      {
        key: 'kulukategoriat',
        label: 'Kulukategoriat',
        text: 'Kulukategoriat Verohallinnon kohtien mukaan.',
      },
      { key: 'ohjeet', label: 'Ohjeet', text: 'Ohjesivut ja usein kysytyt kysymykset.' },
    ],
  },
];
